function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 *
 * Function that transforms string options into object options with keys of
 * `key` and `value`
 *
 * @name serializeOptions
 * @type Function
 * @param {Array} optionArray - Array of option values
 * @returns {Array} Array of object options
 *
 * @example
 *
 * const options = ['apple', 'banana']
 *
 * serializeOptions(options)
 *
 * // [{ key: 'apple', value: 'apple' }, { key: 'banana', value: 'banana' }]
 *
 */
export default function serializeOptions(optionArray) {
  return optionArray.map(function (option) {
    return _typeof(option) === 'object' ? option : {
      key: option,
      value: option
    };
  });
}